export default __webpack_public_path__ + "images/faceIdV2.v-2cc08c76d4351996534269cfee166a86.svg";